import {NavLink as NavLinkBase} from 'react-router-dom';
import styled from 'styled-components';
import {useBreakpoints, useSession} from '@/hooks';
import {paths} from '@/router';
import {FlexCenter, interceptProps} from '@/styled-components';
import {LAYOUT_SIZE, LAYOUT_Z_INDEX, palette} from '@/styles';
import {typographyStyle} from '../Typography';
import LogoImg from './assets/logo.svg';
import {MobileNavBar} from './MobileNavBar';
import {SideElementWrapper} from './StyledComponents';
import {UserMenu} from './UserMenu';

interface IProps {
  disabled?: boolean;
  hideMobileNav?: boolean;
  logoOnly?: boolean;
}

export const NavBar = ({disabled, hideMobileNav, logoOnly}: IProps) => {
  const {hasSession, isPaidUser} = useSession();
  const {isMobile} = useBreakpoints();

  if (isMobile && !hideMobileNav) {
    return <MobileNavBar disabled={disabled} logoOnly={logoOnly} />;
  }

  return (
    <Root disabled={disabled}>
      <SideElementWrapper>
        <NavLink to={paths.home}>
          <Logo>
            <img src={LogoImg} alt="마이프차" />
          </Logo>
        </NavLink>
      </SideElementWrapper>
      {!logoOnly && (
        <>
          <MenuBody>
            <MenuLink to={{pathname: paths.intro}}>서비스 소개</MenuLink>
            <MenuLink to={{pathname: paths.pricing_root}}>요금제</MenuLink>
            {isPaidUser && (
              <MenuLink to={{pathname: paths.map_root}}>지도</MenuLink>
            )}
          </MenuBody>
          {hasSession ? (
            <RightActions>
              <UserMenu />
            </RightActions>
          ) : (
            <SideElementWrapper justifyContent="end">
              <NavLink to={{pathname: paths.signin}}>회원가입/로그인</NavLink>
            </SideElementWrapper>
          )}
        </>
      )}
    </Root>
  );
};

const Root = styled('div').withConfig({
  shouldForwardProp: interceptProps(['disabled']),
})<{
  disabled?: boolean;
}>`
  ${({disabled}) => disabled && `opacity: 0.3;  pointer-events: none;`}
  position: relative;
  display: flex;
  align-items: center;
  height: ${LAYOUT_SIZE.NAV_HEIGHT}px;
  width: 100%;
  background-color: ${palette.white};
  border-bottom: solid 1px ${palette.gray200};
  padding: 0 16px;
  z-index: ${LAYOUT_Z_INDEX.NAVBAR};
  flex-shrink: 0;
`;

const MenuBody = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const Logo = styled(FlexCenter)`
  width: 95px;
  height: 18px;
`;

const NavLink = styled(NavLinkBase)`
  &:hover {
    background-color: ${palette.gray150};
  }
  border-radius: 10px;
  display: inline-block;
  padding: 8px;
  ${{...typographyStyle.bold14}}
`;

const MenuLink = styled(NavLink)`
  &.active {
    color: ${palette.primary400};
    cursor: default;
    &:hover {
      background-color: transparent;
    }
  }
`;

const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
`;

